import { FieldError } from "react-hook-form";

export const ErrorForm = ({ error }: { error?: FieldError }) => {
  /*return <span className="form-input_error-message">Its a errors</span>;*/

  return (
    <div className="form-input_error-container" style={{ 
      minHeight: "20px", 
      position: "relative",
      marginTop: "4px"
    }}>
      {error && (
        <span 
          className="form-input_error-message" 
          style={{ 
            color: "#dc3545", 
            fontSize: "0.875rem",
            display: "block"
          }}
        >
          {error.message}
        </span>
      )}
    </div>
  );
};
